module.exports = __webpack_public_path__ + "static/spokoj_main_3-966e275a3ef7458a9925ab76069f0005.png";